<template>
  <div class="p-4">
    <h1 class="text-xl font-semibold">
      {{ $t('hit-admin.common.settings') }}
    </h1>
  </div>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'SettingsPage',
});
</script>

<style lang="scss" scoped></style>
